
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import { Novedad } from '@/__env/lib/Sistema/Novedades';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        public Cargando: boolean = false;
        public Abierto: boolean = false;

        async Iniciar()
        {

            this.Novedad = await Novedad.Ultima();
            if ( this.Novedad && this.Novedad.Existe )
            {
                this.Vistas.clear();
                this.Total = this.Novedad.Items.length;
                this.Items = this.Novedad.Items;
                this.Abierto = false;
                this.$nextTick( () => this.Abierto = true );
                this.Pagina = 0;
            }


        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push(
                Utiles.onNovedades.subscribe( x =>
                {

                    if ( x )
                        this.Iniciar();
                    else
                        this.Abierto = false;
                } ) );
        }

        @Prop() public Controlador: ControladorBase;
        public get Usuario() { return this.Controlador.Usuario; };


        public Novedad: Novedad = new Novedad();
        public Vistas: number[] = [];
        public Items: string[] = [];
        public Total: number = 0;
        public Pagina: number = null;
        @Watch( 'Pagina', { immediate: true } )
        onPagina()
        {
            if ( this.Vistas.findIndex( x => x == this.Pagina ) == -1 )
                this.Vistas.push( this.Pagina );
        }
        Previo()
        {
            this.Pagina = this.Pagina - 1 < 0 ? this.Total - 1 : this.Pagina - 1;

        }

        Siguiente()
        {
            this.Pagina = this.Pagina + 1 === this.Total ? 0 : this.Pagina + 1;

        }

        Cerrar()
        {
            if ( this.Total <= this.Vistas.length )
            {
                this.Novedad.MarcarVista();
                this.Abierto = false;
            } else
            {
                for ( var i = 0; i < this.Total; i++ )
                {
                    if ( this.Vistas.findIndex( x => x == i ) == -1 )
                    {
                        this.Pagina = i;
                        break;

                    }
                }
            }

        }
    }
